import {gql} from 'apollo-angular';


export const phonesGql = gql`
query ReloadPhonesQuery($participantId: [Int!]) {
  Participant (participantId: $participantId){
    participantId
    event {
      eventId
    }
    individualConstituent {
      constituentPhones {
        constituentPhoneId
        areaCode
        countryCode
        primaryFl
        phoneNumber
        phoneType {
          cmgmtPhoneTypeId
          name
          description
        }
      }
    }
  }
}
`;